import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Section from "../Section";
import { Grid, Typography, Button } from "@material-ui/core";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { FormattedMessage, injectIntl } from "react-intl";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
const useStyles = makeStyles(theme => ({
    fullWidth: {
        width: "100%"
    },
    header: {
        alignItems: "center",
        display: "flex"
    },
    editButton: {}
}), { name: "DployLockAndEditableSection" });
addRegisteredSectionLayout({
    name: "LockAndEditableSection",
    displayName: "LockAndEditableSection",
    settings: {
        editableOptions: {
            editButtonAtBottom: true,
            hideEditAndSaveIcons: true
        }
    }
});
const LockAndEditableSection = injectIntl((props) => {
    const { className, onClick, sectionTitle, editButtonAtBottom, hideEditAndSaveIcons } = props;
    const classes = useStyles();
    const alwaysLocked = props.fields.find(x => x.name === "AlwaysLockedSection");
    const [sectionIsEditable, setSectionIsEditable] = useState(false);
    const IconButton = sectionIsEditable ? SaveIcon : EditIcon;
    const editButton = !alwaysLocked ? (_jsx(Button, { onClick: () => setSectionIsEditable(!sectionIsEditable), color: "secondary", endIcon: !hideEditAndSaveIcons && _jsx(IconButton, {}), className: classes.editButton, children: sectionIsEditable ? (_jsx(FormattedMessage, { id: "template-form.section.lockAndEditableSection.save", defaultMessage: "Save" })) : (_jsx(FormattedMessage, { id: "template-form.section.lockAndEditableSection.edit", defaultMessage: "Edit" })) })) : null;
    return (_jsxs(Grid, { container: true, spacing: 3, className: clsx(className), onClick: onClick, justifyContent: "center", children: [_jsxs(Grid, { container: true, direction: "row", justifyContent: "space-between", className: classes.header, children: [_jsx(Grid, { item: true, children: _jsx(Typography, { variant: "h5", children: sectionTitle }) }), !editButtonAtBottom && _jsx(Grid, { item: true, children: editButton })] }), _jsx(Section, { ...props, sectionTitle: undefined, literal: !sectionIsEditable }), editButtonAtBottom && editButton] }));
});
LockAndEditableSection.displayName = "DployLockAndEditableSection";
export { LockAndEditableSection };
//# sourceMappingURL=LockAndEditableSection.js.map